module.exports = __webpack_public_path__ + "notification.1eb78726.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/headers/notification.gif
// module id = 385
// module chunks = 0